import CommonSharedFileDetail from '../../../common/pages/secure/SharedFileDetail'
import Config from '../../../Config'

class SharedFileDetail extends CommonSharedFileDetail {
  constructor (props) {
    super(props)
    this.apiUrl = Config.companyUserApiUrl.systemSettings
    this.apiUrlToDownlaod = Config.companyUserApiUrl.sharedFileDownlaod
    this.userRoleUrl = 'company_user'
    this.userRole = 'companyUser'
    this.isShowingEditButton = false
    this.isShowingDeleteButton = false
  }
}

export default SharedFileDetail



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/SharedFileDetail.js